var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLocationOn = function SvgLocationOn(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12c.6 0 1-.2 1.4-.6s.6-.8.6-1.4-.2-1-.6-1.4A2 2 0 0 0 12 8a2 2 0 0 0-1.4.6A2 2 0 0 0 10 10c0 .6.2 1 .6 1.4s.8.6 1.4.6m0 9.6h-.4l-.3-.3a31 31 0 0 1-5.5-6 9.6 9.6 0 0 1-1.8-5q0-3.75 2.4-6A8 8 0 0 1 12 2a8 8 0 0 1 5.6 2.2 7.7 7.7 0 0 1 2.4 6c0 1.6-.6 3.3-1.8 5.2a31 31 0 0 1-5.8 6.2z"
  })));
};
export default SvgLocationOn;